import {
  Button,
  ClickAwayListener,
  FormControl,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Popper,
  Select,
  TextField,
  makeStyles,
} from "@material-ui/core";
import React, { useState, useRef } from "react";
import "./gridControls.scss";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import CloseIcon from "@material-ui/icons/Close";
import OverflowComponent from "./OverflowComponent";
import ValueDetail from "./ValueDetail";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { update } from "lodash";

const MultiValueLabels = ({
  dd,
  model,
  tab,
  searchPlaceHolderText,
  values,
  onCreate,
  onUpdate,
  onDelete,
  sortUpdate,
  sort,
  disabled = false,
}) => {
  const useStyles = makeStyles((theme) => ({
    itemContainer: {
      margin: "8px 0",
      alignItems: "center",
      "&:hover": {
        backgroundColor: "#F3FAFF;",
      },
    },
  }));
  const classes = useStyles();
  const dragRef = useRef();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDrag, setIsDrag] = useState(false);
  const [over, setOver] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = (event) => {
    if (tab === "DD-Values") {
      if (isDrag) {
        sortUpdate(finalMenuList);
        setIsDrag(false);
      }
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popId = open ? "simple-popper" : undefined;
  const [finalMenuList, setFinalMenuList] = useState(values);
  const onSearchOptions = (e) => {
    const { value } = e.target;
    if (e.key === "Enter" && value.trim() !== "") {
      const fieldValues = value.split(",");
      const fieldValueMenuList = [];
      fieldValues.forEach((f) => {
        fieldValueMenuList.push({ name: f, description: "" });
      });
      setFinalMenuList([...finalMenuList.concat(fieldValueMenuList)]);
      e.target.value = "";
      if (tab === "DD-Values") {
        for (let i = 0; i < fieldValueMenuList.length; i++) {
          let name = fieldValueMenuList[i]?.name;
          let desc = fieldValueMenuList[i]?.description;
          let sortNo = finalMenuList.length + i + 1
          onCreate(model, dd, name, desc, sortNo);
        }
      }
    }
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    const items = Array.from(finalMenuList);
    const [reorderedItem] = items.splice(droppedItem.source.index, 1);
    items.splice(droppedItem.destination.index, 0, reorderedItem);
    setFinalMenuList(items);
    setIsDrag(true);
  };

  const removeItem = (item) => {
    setFinalMenuList([
      ...finalMenuList.filter((listValue) => item !== listValue),
    ]);
    if (tab === "DD-Values") {
      onDelete(model, dd, item?.id);
    }
  };

  const handleDots = (i) => {
    const list = [...finalMenuList];
    list.map((item, index) => {
      if (i === index) {
        item.enable = true;
      } else {
        item.enable = false;
      }
    });
    setFinalMenuList(list);
  };

  return (
    <div
      className="contained-grid-container"
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? "0.4" : "1",
      }}
    >
      {typeof values === "string" && "NA"}
      {typeof values === "object" && (
        <OverflowComponent
          onClick={(e)=>{
            if(!disabled){ handleClick(e)}
          }}
          items={finalMenuList?.map((e) => e.name)}
        />
      )}
      <Popper id={popId} open={open} anchorEl={anchorEl} placement="bottom">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div
            style={{
              height: "324px",
              width: "380px",
              border: "1px none #fffff",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              marginLeft: "17px",
            }}
          >
            <Grid xs={12} container>
              <Grid
                item
                container
                style={{
                  backgroundColor: "#D1E9FD",
                  borderBottom: "1px solid #D1E9FD",
                }}
              >
                <TextField
                  fullWidth
                  variant="standard"
                  style={{ fontSize: "12px", padding: "0 10px" }}
                  placeholder={searchPlaceHolderText}
                  onKeyUp={onSearchOptions}
                ></TextField>
              </Grid>
              <Grid
                item
                container
                xs={12}
                spacing={0}
                style={{ paddingTop: "0px" }}
              >
                <div ref={dragRef} style={{ width: "100%" }}>
                  <DragDropContext onDragEnd={handleDrop}>
                    <Droppable droppableId={`finalMenuList`}>
                      {(provided) => (
                        <div
                          className="menu-list"
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {!!finalMenuList?.length &&
                            finalMenuList?.map((item, index) => {
                              return (
                                <Draggable
                                  id={item?.id}
                                  key={item?.id}
                                  draggableId={`${item?.id}`}
                                  index={index}
                                >
                                  {(provided2) => (
                                    <Grid
                                      key={index}
                                      onMouseOver={() => handleDots(index)}
                                      item
                                      xs={12}
                                      container
                                      className={classes.itemContainer}
                                      ref={provided2.innerRef}
                                      {...provided2.draggableProps}
                                      {...provided2.dragHandleProps}
                                    >
                                      <Grid item xs={10} spacing={0}>
                                        <span
                                          style={{
                                            marginLeft: "8px",
                                            backgroundColor: "#E5E7ED",
                                            padding: "6px",
                                            width: "45%",
                                            float: "left",
                                          }}
                                        >
                                          <DragIndicatorIcon
                                            className="grid-action-item-multi"
                                            style={{
                                              cursor: "move",
                                              marginBottom: "-6px",
                                            }}
                                            fontSize="small"
                                          />
                                          {item.name}
                                          <CloseIcon
                                            style={{
                                              marginBottom: "-6px",
                                              paddingLeft: "4px",
                                              color: "#BAC0D0",
                                            }}
                                            fontSize="small"
                                            onClick={() => removeItem(item)}
                                          />
                                        </span>
                                        <span
                                          style={{
                                            padding: "6px",
                                            opacity: 0.5,
                                            width: "44%",
                                            float: "left",
                                          }}
                                        >
                                          {item.description !== ""
                                            ? item.description
                                            : "No Description"}
                                        </span>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={2}
                                        justify="flex-end"
                                        container
                                      >
                                        {item?.enable && (
                                          <ValueDetail
                                            valueName={item.name}
                                            description={item.description}
                                            onUpdate={onUpdate}
                                            model={model}
                                            dd={dd}
                                            tab={tab}
                                            ddValueId={item?.id}
                                            item={item}
                                            sort={item?.sort}
                                          />
                                        )}
                                      </Grid>
                                    </Grid>
                                  )}
                                </Draggable>
                              );
                            })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </Grid>
            </Grid>
          </div>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default MultiValueLabels;
